export const EVENT_TYPES = {
  GENERAL: 'general',
  PAGE_ENTER: 'page_enter',
  PAGE_LEAVE: 'page_leave',
  BUTTON_CLICK: 'button_click',
  INPUT: 'input',
  CHAT: 'chat',
  VOICE: 'voice',
  FEATURE: 'feature',
  AI: 'ai',
  SESSION_START: 'session_start',
  SESSION_END: 'session_end',
  CHAT_MSG: 'chat_msg',
  CRITICAL: 'critical',
} as const;

export const GENERAL_EVENTS = {
  CHATBOT_OPENED: 'chatbot.opened',

  MY_REQUEST_DETAIL_CSAT_SEEN: 'my_request.detail.csat.seen',
  CONNECT_REQUEST_TRANSACTION_REMEDY_SHOWN: 'connect_request.transaction.remedy_shown',
  CONNECT_REQUEST_TRANSACTION_REMEDY_STATUS_CHANGED: 'connect_request.transaction.remedy_status_changed',
  CONNECT_REQUEST_TRANSACTION_REMEDY_MATCH_FAILED: 'connect_request.transaction.remedy_match_failed',
  CONNECT_REQUEST_TRANSACTION_WARNING_SHOWN: 'connect_request.transaction.warning_shown',
  CONNECT_REQUEST_TRANSACTION_METADATA_CHECK_EXTERNAL_API_RESULT: 'connect_request.transaction.metadata_check.external_api_result',
  CONNECT_REQUEST_TRANSACTION_METADATA_CHECK_EXTERNAL_API_ERROR: 'connect_request.transaction.metadata_check.external_api_error',
  CONNECT_REQUEST_TRANSACTION_METADATA_CHECK_RESULT: 'connect_request.transaction.metadata_check.result',
  CONNECT_REQUEST_MESSAGE_SEND: 'connect_request.message_send',
  CONNECT_REQUEST_MESSAGE_SEND_INIT_ERROR: 'connect_request.message_send.init_error',
  CONNECT_REQUEST_MESSAGE_SENT: 'connect_request.message_sent',
  LIVE_CHAT_MSG_SEQUENCE: 'live_chat_msg_sequence',
  MODAL_TRIGGER_OPEN_REQUEST_FAILED: 'modal.trigger.open_request.failed',

  GUEST_FILL_DETAILS: 'guest.fill_details',
  SAVE_GUEST_INFO: 'save_guest_info',
  SAVE_GUEST_INFO_FAILED: 'save_guest_info.failed',
  GUEST_LOGIN_AI_SUGGESTED: 'guest.login.ai_suggested',
  SAVE_GUEST_LOGIN_TOKEN_FAILED: 'save_guest_login_token.failed',

  // Guest OTP Verification API Events
  GUEST_OTP_SEND_ATTEMPT: 'guest.otp.send_attempt',
  GUEST_OTP_SEND_SUCCESS: 'guest.otp.send_success',
  GUEST_OTP_SEND_FAILED: 'guest.otp.send_failed',
  GUEST_OTP_VERIFY_ATTEMPT: 'guest.otp.verify_attempt',
  GUEST_OTP_VERIFY_SUCCESS: 'guest.otp.verify_success',
  GUEST_OTP_VERIFY_FAILED: 'guest.otp.verify_failed',
  GUEST_OTP_RESEND_ATTEMPT: 'guest.otp.resend_attempt',
  GUEST_OTP_RESEND_SUCCESS: 'guest.otp.resend_success',
  GUEST_OTP_RESEND_FAILED: 'guest.otp.resend_failed',
  GUEST_TICKET_CREATED: 'guest.ticket.created',
  GUEST_OTP_INCORRECT: 'guest.otp.incorrect',

  FILE_UPLOAD_ERROR: 'file_upload_error',
  FILE_UPLOAD_INVALID_TYPE: 'file_upload_invalid_type',
  FILE_UPLOAD_SIZE_EXCEEDED: 'file_upload_size_exceeded',
  SELECTED_ENTITY_FLOW: 'selected_entity_flow',
} as const;

export const PAGE_EVENTS = {
  ACTIVE_CONVERSATION_HOME: 'active_conversation.home',
  ACTIVE_CONVERSATION_TICKET: 'active_conversation.ticket',

  MY_REQUESTS_HOME: 'my_request.home',
  MY_REQUESTS_DETAIL: 'my_request.detail',
  ARTICLE: 'article',
  CSAT: 'csat',
  VOICE_CHAT: 'voice_chat',

  MODAL_CONFIRM_RESUMABLE_CHAT_API_NO_DATA_RECEIVED: 'confirm_resumable_chat_api_no_data_received',
  MODAL_CONFIRM_RESUMABLE_CHAT_API_FAILED: 'modal.confirm_resumable_chat_api_failed',
  MODAL_CONFIRM_RESUMABLE_CHAT: 'modal.confirm_resumable_chat',
  MODAL_CLOSED_AC_CHAT: 'modal.closed_active_conversation_chat',
  MODAL_CLOSED_MY_REQUEST_CHAT: 'modal.closed_my_request_chat',

  MODAL_TRIGGER_POP_UP: 'modal.trigger.pop_up',
  MODAL_TRIGGER_OPEN_REQUEST: 'modal.trigger.open_request',

  MODAL_THRESHOLD_LIMIT: 'modal.threshold_limit',

  CONNECT_REQUEST: 'connect_request',
  CONNECT_REQUEST_LOGIN: 'connect_request.login',
  CONNECT_REQUEST_GUEST: 'connect_request.guest',
  CONNECT_REQUEST_TRANSACTION: 'connect_request.transaction',
  CONNECT_REQUEST_DESCRIPTION: 'connect_request.description',
  CONNECT_REQUEST_CONNECT_OPTIONS: 'connect_request.connect_options',
  CHAT_ROOM: 'chat_room',

  // Guest OTP Verification Page Events
  GUEST_TICKET_CONFIRMATION: 'guest.ticket.confirmation',
} as const;

export const BTN_EVTS = {
  CHATBUBBLE_OPEN: 'chatbubble.open',
  ACTIVE_CONVERSATION_SHOW_ALL: 'active_conversation.home.show_all',
  ACTIVE_CONVERSATION_NEW_CONVERSATION: 'active_conversation.home.new_conversation',
  ACTIVE_CONVERSATION_SELECTED: 'active_conversation.selected',

  HOME_HEADER_MY_REQUESTS: 'home.header.my_requests',
  HOME_HEADER_MENU_MINIMIZE: 'home.header.menu.minimize',
  SEARCH_ARTICLE: 'search_article',
  SEARCH_ARTICLE_RESULT: 'search_article.result',
  SEARCH_ARTICLE_RECENT_SEARCH_ARTICLE: 'search_article.recent_search_article',
  MY_REQUEST_HOME_PAGINATE_BUTTON: 'my_request.home.paginate_button',

  MY_REQUEST_DETAIL_SELECTED: 'my_request.detail.selected',

  ARTICLE_HELPFUL: 'article.helpful',
  ARTICLE_NOT_HELPFUL: 'article.not_helpful',
  ARTICLE_RELATED_ARTICLE: 'article.related_article',
  ARTICLE_SEARCH_BOTTOM: 'article.search.bottom',
  ARTICLE_INTERACT_BACK: 'article.interact.back',
  ARTICLE_INTERACT_CONTACT_SUPPORT: 'article.interact.contact_support',
  ARTICLE_INTERACT_ACTION: 'article.interact.action',

  VOICE_CHAT_END: 'voice_chat.end',

  MODAL_CONFIRM_RESUMABLE_CHAT_CONTINUE: 'modal.confirm_resumable_chat.continue',
  MODAL_CONFIRM_RESUMABLE_CHAT_END_CHAT: 'modal.confirm_resumable_chat.end_chat',

  MODAL_CLOSED_AC_CHAT_GO_TO_AC: 'modal.closed_active_conversation.go_to_active_conversation',
  MODAL_CLOSED_AC_CHAT_NEW_CONVERSATION: 'modal.closed_active_conversation.new_conversation',

  MODAL_CLOSED_MY_REQUEST_CHAT_GO_TO_MY_REQUESTS: 'modal.closed_my_request.go_to_my_requests',
  MODAL_CLOSED_MY_REQUEST_CHAT_NEW_CONVERSATION: 'modal.closed_my_request.new_conversation',

  MODAL_TRIGGER_POP_UP_CONTINUE: 'modal.trigger.pop_up.continue',
  MODAL_TRIGGER_POP_UP_END_CHAT: 'modal.trigger.pop_up.end_chat',

  MODAL_TRIGGER_OPEN_REQUEST_END_CHAT: 'modal.trigger.open_request.end_chat',
  MODAL_TRIGGER_OPEN_REQUEST_CLICKED: 'modal.trigger.open_request.open_request_clicked',
  MODAL_TRIGGER_OPEN_REQUEST_GO_TO_MY_REQUESTS: 'modal.trigger.open_request.go_to_my_requests',
  MODAL_TRIGGER_OPEN_REQUEST_BACK: 'modal.trigger.open_request.back',
  MODAL_TRIGGER_OPEN_REQUEST_PROCEED: 'modal.trigger.open_request.proceed',
  MODAL_TRIGGER_OPEN_REQUEST_BROWSE_OTHER_TOPICS: 'modal.trigger.open_request.browse_other_topics',
  MODAL_TRIGGER_OPEN_REQUEST_RESTART_CHAT: 'modal.trigger.open_request.restart_chat',

  MODAL_THRESHOLD_LIMIT_BACK: 'modal.threshold_limit.back',
  MODAL_THRESHOLD_LIMIT_OPEN_REQUEST: 'modal.threshold_limit.open_request',
  MODAL_THRESHOLD_LIMIT_LIVE_CHAT: 'modal.threshold_limit.live_chat',
  MODAL_THRESHOLD_LIMIT_CALL: 'modal.threshold_limit.call',

  CONNECT_REQUEST_LOGIN_CLICKED: 'connect_request.login.login_clicked',
  CONNECT_REQUEST_LOGIN_CONTINUE_AS_GUEST: 'connect_request.login.continue_as_guest',
  CONNECT_REQUEST_DESCRIPTION_SUBMITTED: 'connect_request.description.submitted',
  CONNECT_REQUEST_CANCEL_TRASH: 'connect_request.cancel_trash',
  CONNECT_REQUEST_CANCEL_NO_CANCEL: 'connect_request.cancel.no_cancel',
  CONNECT_REQUEST_CANCEL_YES_CANCEL: 'connect_request.cancel.yes_cancel',
  CONNECT_REQUEST_TRANSACTION_SELECTED: 'connect_request.transaction.selected',
  CONNECT_REQUEST_TRANSACTION_GO_TO_TICKET: 'connect_request.transaction.go_to_ticket',
  CONNECT_REQUEST_TRANSACTION_CHECK_STATUS: 'connect_request.transaction.check_status',
  CONNECT_REQUEST_TRANSACTION_GO_TO_TRANSACTIONS: 'connect_request.transaction.go_to_transactions',
  CONNECT_REQUEST_TRANSACTION_PROCEED: 'connect_request.transaction.proceed',
  CONNECT_REQUEST_TRANSACTION_WARNING_CANCEL: 'connect_request.transaction.warning.cancel',
  CONNECT_REQUEST_TRANSACTION_END_CHAT: 'connect_request.transaction.transaction.end_chat',
  CONNECT_REQUEST_TRANSACTION_DIRECT_TICKET_CREATION: 'connect_request.transaction.direct_ticket_creation',
  CONNECT_REQUEST_TRANSACTION_METADATA_CHECK: 'connect_request.transaction.metadata_check',

  CHAT_ROOM_ACTIVE_CONVERSATION_HEADER: 'chat_room.active_conversation_header',
  CHAT_ROOM_MESSAGE_OPTION_CLICKED: 'chat_room.message_option_clicked',
  CHAT_ROOM_EXTERNAL_OPTION_CLICKED: 'chat_room.external_option_clicked',
  CHAT_ROOM_FLOATING_HAMBURGER_CLICK: 'chat_room.floating_hamburger_click',
  CHAT_ROOM_FLOATING_HAMBURGER_OPTION_SELECTED: 'chat_room.floating_hamburger.option_selected',
  CHAT_ROOM_CHAT_END_CHAT: 'chat_room.chat.end_chat',
  CHAT_ROOM_RESOLVED_SUPPORT_REQUEST: 'chat_room.resolved_support_request_click',

  // Guest OTP Verification Button Events
  GUEST_CONTINUE_AS_GUEST_CLICKED: 'guest.continue_as_guest.clicked',
  GUEST_OPEN_REQUEST_CLICKED: 'guest.open_request.clicked',
  GUEST_OPEN_REQUEST_FLOW_STARTED: 'guest.open_request.flow_started',
  GUEST_OTP_CHANGE_EMAIL: 'guest.otp.change_email',
  GUEST_TICKET_CONFIRMATION_CLOSE: 'guest.ticket.confirmation.close',
} as const;

export const CHAT_EVENTS = {
  CHAT_ROOM_CHAT_MEMBER_JOINED: 'chat_room.chat.member_joined',
  CHAT_ROOM_CHAT_MEMBER_LEFT: 'chat_room.chat.member_left',
} as const;

export const VOICE_EVENTS = {
  DEVICE_REGISTERING: 'device.registering',
  DEVICE_REGISTERED: 'device.registered',
  DEVICE_ERROR: 'device.error',
  DEVICE_UNREGISTERED: 'device.unregistered',
  DEVICE_REGISTER: 'device.register',
  CALL_ACCEPTED: 'call.accepted',
  CALL_CONNECTED_SUCCESSFUL: 'call.connected_successful',
  CALL_CONNECTED_FAILED: 'call.connected_failed',
  CALL_ERROR: 'call.error',
  CALL_CANCEL: 'call.cancel',
  CALL_RECONNECTING: 'call.reconnecting',
  CALL_RECONNECTED: 'call.reconnected',
  CALL_DISCONNECTED: 'call.disconnected',
  CALL_SAMPLE: 'call.sample',
  SILENT_CALL: 'silent_call',

  VOICE_HANDLE: 'voice.handle',
  VOICE_HANDLE_CANCEL: 'voice.handle.cancel',
  VOICE_HANDLE_CALL: 'voice.handle.call',
  VOICE_MICROPHONE_PERMISSION: 'voice.mic_permission',
  VOICE_MICROPHONE_PERMISSION_OPEN_SETTINGS: 'voice.mic_permission.open_settings',
  VOICE_MICROPHONE_PERMISSION_DENIED: 'voice.mic_permission.denied',
} as const;

export const INPUT_EVENTS = {
  CHAT_ROOM_END_USER_SENT_MESSAGE: 'chat_room.end_user.sent_message',
  CHAT_ROOM_END_USER_SENT_ATTACHMENT: 'chat_room.end_user.sent_attachment',
} as const;

export const FEATURES_EVENTS = {
  PREDICTIVE_OPTIONS_MATCHED: 'predictive_options.matched',
  METADATA_AUTOMATION_MATCHED: 'metadata_automation.matched',
  METADATA_AUTOMATION_HELPFUL: 'metadata_automation.helpful',
  METADATA_AUTOMATION_NOT_HELPFUL: 'metadata_automation.not_helpful',

  AI_ELIGIBLE: 'ai.eligible',
  AI_TRANSACTION_ELIGIBLE: 'ai.transaction.eligible',
  AI_BETS_ELIGIBLE: 'ai.bets.eligible',
} as const;

export const AI_EVENTS = {
  AI_CHECK_ELIGIBLE: 'ai.check_eligible',
  AI_RUN_CONNECT_TO_AI: 'ai.run_connect_to_ai',
  AI_SESSION_START: 'ai.session_start',
  AI_USER_INPUT: 'ai.user_input',
  AI_USER_REQUEST: 'ai.user_request',
  AI_RESPONSE_FIRST: 'ai.ai_response.first',
  AI_RESPONSE_FOLLOW_UP: 'ai.ai_response.follow_up',
  AI_ERROR_RESPONSE: 'ai.error_response',
  AI_OVERLONG_CONVERSATION_CONNECT_SUPPORT: 'ai.overlong_conversation.connect_support',
  AI_CONNECT_SUPPORT_RESPONSE: 'ai.connect_support_response',
  AI_END_CHAT_RESPONSE: 'ai.end_chat_response',
  AI_TICKET_END_CHAT_RESPONSE: 'ai.ticket_end_chat_response',
  AI_SHOW_TRANSACTION_SELECTOR: 'ai.show_transaction_selector',
  AI_PARSED_RESPONSE_ISSUE: 'ai.parsed_response_issue',
  AI_RESUME_CHAT: 'ai.resume.chat',
  AI_INTERVENE_CHAT: 'ai.intervene.chat',

  AI_STALE_CONVERSATION: 'ai.stale_conversation',
  AI_STALE_CONVERSATION_RESUME: 'ai.stale_conversation.resume',
  AI_STALE_CONVERSATION_END: 'ai.stale_conversation.end',

  AI_COLLECT_FILE: 'ai.collect_file',
  AI_FILE_UPLOAD_ERROR: 'ai.file_upload_error',
  AI_GUEST_LOGIN: 'ai.guest.login',
} as const;

export const CRITICAL_EVENTS = {
  CHATBOT_INIT_ERROR: 'chatbot.init_error',
  CHATBOT_FAILED_LOAD_BRAND_CONFIG: 'chatbot.failed_load_brand_config',
  CHATBOT_FAILED_LOAD_LOCALES: 'chatbot.failed_load_locales',

  CONNECT_OPTIONS_CHAT_INITIATED_ERROR: 'connect_options.chat.initiated.error',
  CONNECT_OPTIONS_CALL_INITIATED_ERROR: 'connect_options.call.initiated.error',
  CONNECT_OPTIONS_OPEN_REQUEST_INITIATED_ERROR: 'connect_options.open_request.initiated.error',

  OPEN_REQUEST_SUBJECT_MISSING: 'open_request.subject.missing',
  OPEN_REQUEST_DESCRIPTION_MISSING: 'open_request.description.missing',
  OPEN_REQUEST_SHORT_DESCRIPTION: 'open_request.short_description',

  CONNECT_REQUEST_MESSAGE_SEND_ERROR: 'connect_request.message_send.error',

  // Guest OTP Verification Critical Events
  GUEST_OTP_GENERAL_ERROR: 'guest.otp.general_error',
} as const;

// Context/Page name for components used in the application on several pages - to determine
// parent part of the event name
export const CMP_CONTEXTS = {
  ACTIVE_CONVERSATION: 'active_conversation.',
  ACTIVE_CONVERSATION_TICKET: 'active_conversation.ticket.',
  MY_REQUEST: 'my_request.home.',
  MY_REQUEST_DETAIL: 'my_request.detail.',
  ARTICLE: 'article.',
  CHAT_ROOM: 'chat_room.',
  CONNECT_REQUEST: 'connect_request.',
} as const;

// Events for components used in the application on several pages. To not duplicate event names
// with different contexts and resolve it on component level
export const COMPONENT_EVENTS = {
  HEADER_BACK: 'header.back',
  HEADER_END_CHAT: 'header.end_chat',

  CONNECT_OPTIONS: 'connect_options',
  CONNECT_OPTIONS_CHAT: 'connect_options.chat',
  CONNECT_OPTIONS_CALL: 'connect_options.call',
  CONNECT_OPTIONS_FOLLOW_UP: 'connect_options.follow_up',
  CONNECT_OPTIONS_OPEN_REQUEST: 'connect_options.open_request',

  CONNECT_OPTIONS_REFRESH_CHANNEL: 'connect_options.refresh_channel',
  CONNECT_OPTIONS_SHOWN: 'connect_options.shown',

  CONNECT_OPTIONS_CHAT_INITIATED: 'connect_options.chat.initiated',
  CONNECT_OPTIONS_CALL_INITIATED: 'connect_options.call.initiated',

  CONNECT_OPTIONS_CHAT_CREATED: 'connect_options.chat.created',
  CONNECT_OPTIONS_CALL_CREATED: 'connect_options.call.created',
  CONNECT_OPTIONS_OPEN_REQUEST_CREATED: 'connect_options.open_request.created',
  CONNECT_OPTIONS_FOLLOW_UP_SENT: 'connect_options.follow_up.sent',

  CSAT_CLICKED: 'csat.clicked',
  CSAT_FEEDBACK_OPTION: 'csat.feedback_option',
  CSAT_SKIP: 'csat.skip',
  CSAT_SUBMITTED: 'csat.submitted',

  CSAT_LOW_RATING_SHOWN: 'csat.low_rating.shown',
  CSAT_LOW_RATING_CONNECT_SUPPORT: 'csat.low_rating.connect_support',
  CSAT_LOW_RATING_CLOSE: 'csat.low_rating.close',
} as const;
